import { render } from "./LoginOTPView.vue?vue&type=template&id=d3c236f0"
import script from "./LoginOTPView.vue?vue&type=script&lang=js"
export * from "./LoginOTPView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__